// extracted by mini-css-extract-plugin
export default {"progressBar":"Steps-index__progressBar--pVc_a"};